
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import {
  GOOGLE_URL,
  INTRODUCTION_IMG,
  INTRODUCTION_RIP_NEW,
} from './IntroductionSection.constants'
import translations from './IntroductionSection.translations'

export default {
  components: {
    RevButton,
    RevLink,
    FormattedMessage,
    RevIllustration,
  },
  computed: {
    translations: () => translations,
    INTRODUCTION_IMG: () => INTRODUCTION_IMG,
    INTRODUCTION_RIP_NEW: () => INTRODUCTION_RIP_NEW,
    GOOGLE_URL: () => GOOGLE_URL,
    ctaRoute() {
      return { name: ROUTES.ABOUT_US }
    },
  },
  methods: {
    trackInteraction() {
      trackClick({ zone: 'detail', name: 'get_to_know_us' })
    },
  },
}
